import { Box, Typography, Button } from '@mui/material';
import React, { useContext, useEffect, useState, useRef } from 'react';
import { BreadcrumbComponent } from '../BreadcrumbComponent/BreadcrumbComponent';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import Content from '../Layout/Content';
import { useLocation } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_PRICE_LIST_DATA_UNAUTH } from '../../services/PriceTransparencyQueries/PriceTransparencyService';
import { SimpleBackdrop } from '../SimpleBackdropComponent/SimpleBackdrop';
import { useSnackbar } from 'notistack';
import NotFound from '../NotFound/NotFoundPage';
import ApplicationContext from '../../context/applicationContext';
import {
  prescriptionTableHeading,
  convertToTitleCase,
  removeUnwantedColumns,
} from '../../shared/helper';
import { DownloadFile, getIconFromSubItemsArray } from '../../shared/helper';
import SearchBar from '../../components/SearchBar/Search';
import { styled } from '@mui/system';
import { COVERAGE, PRICE_LIST } from '../../shared/Strings';
import GlobalContext from '../../context/globalContext';
import PricelistAGgrid from '../CustomAGgrid/PricelistAGgrid';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import PrescriptionFile from '../../assests/Prescription drug.json';
import InNetFile from '../../assests/in-netdemo.json';
import OutNetFile from '../../assests/out-netdemo.json';

const table = {
  '& .css-1kn3lhz': {},
  mt: 4,
};

const valueToFileTypeMapping = {
  1: 'IN_NETWORK_RATE',
  2: 'OUT_OF_NETWORK',
  3: 'PRESCRIPTION_DRUG',
};

function formatTableHeadingForAGgrid(data) {
  return data.map(item => {
    return {
      field: item,
      headerName: convertToTitleCase(item),
      tooltipField: convertToTitleCase(item),
      headerTooltip: convertToTitleCase(item),
    };
  });
}

function formatPrescriptionHeading(data) {
  return data.map(item => {
    return {
      field: item,
      headerName: prescriptionTableHeading(item),
      tooltipField: prescriptionTableHeading(item),
      headerTooltip: prescriptionTableHeading(item),
    };
  });
}

const StyledTab = styled(props => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      fontWeight: '600',
      textTransform: 'none',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '18px',
      fontWeight: '600',
      textTransform: 'none',
    },
  })
);
function CoveragePriceList() {
  const { activePlansPriceList } = useContext(GlobalContext);
  const [tableHeading, setTableHeading] = useState([]);
  const [value, setValue] = useState('1');
  const [offset, setOffset] = useState(0);
  const { state } = useLocation();
  const breadcrumbData = [
    { label: 'Coverage and benefits', route: '/financial/coverage' },
    { label: state.title },
  ];
  const [priceListData, setPriceListData] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const { menuItems } = useContext(ApplicationContext);
  const [searchValue, setSearchValue] = useState('');
  const [priceListTableData, setPriceListTableData] = useState([]);

  const onChangeText = text => {
    setSearchValue(text);
  };

  const getPrescriptionFile = (file, flag = false) => {
    let keysArray = [];
    let valueArray = [];
    let heading = [];

    file.forEach((da, index) => {
      for (var key in da) {
        if (!keysArray.includes(key)) {
          keysArray.push(key);
          heading.push(key);
        }
      }
      valueArray[index] = da = {
        ...da,
      };
    });

    setTableHeading(
      flag
        ? formatPrescriptionHeading(heading)
        : formatTableHeadingForAGgrid(heading)
    );
    setPriceListTableData(valueArray);
  };

  useEffect(() => {
    if (activePlansPriceList?.IN_NETWORK_RATE) {
      setValue('1');
    } else if (activePlansPriceList?.OUT_OF_NETWORK) {
      setValue('2');
    } else if (activePlansPriceList?.PRESCRIPTION_DRUG) {
      setValue('3');
    }
    //if no tabs are available in that case IN_NETWORK_RATE will show
    else {
      setValue('1');
    }
  }, []);

  const currentPageNumber = useRef(0);

  useEffect(() => {
    getPrescriptionFile(InNetFile);
  }, []);

  // const {
  //   loading,
  //   errors,
  //   refetch,
  // } = useQuery(GET_PRICE_LIST_DATA_UNAUTH, {
  //   fetchPolicy: 'cache-and-network',
  //   variables: {
  //     planId: 2,
  //     fileCategory: 'IN_NETWORK_RATE',
  //     searchText: '',
  //     offset: offset,
  //     limit: 100,
  //   },
  //   onCompleted: res => {
  //     const resposne = res.getPriceListDataUnauth.data;
  //     setPriceListData(removeUnwantedColumns(resposne));
  //   }
  // });

  // useEffect(() => {
  //   if (priceListData !== null && priceListData.length > 0) {
  //     let keysArray = [];
  //     let valueArray = [];
  //     let heading = [];

  //     priceListData.forEach((da, index) => {
  //       for (var key in da) {
  //         if (!keysArray.includes(key)) {
  //           keysArray.push(key);
  //           heading.push(key);
  //         }
  //       }
  //       valueArray[index] = da = {
  //         ...da,
  //       };
  //     });
  //     setTableHeading(formatTableHeadingForAGgrid(heading));
  //     setPriceListTableData(valueArray);
  //   }
  // }, [priceListData]);

  // useEffect(() => {
  //   if (errors) {
  //     enqueueSnackbar(PRICE_LIST.ON_ERROR_TEXT.WENT_WRONG_PRICE_LIST, {
  //       variant: 'error',
  //     });
  //   }
  // }, [errors, enqueueSnackbar]);

  const handleChange = (event, newValue) => {
    setOffset(0);
    setSearchValue('');
    currentPageNumber.current = 0;
    if (newValue === '3') {
      getPrescriptionFile(PrescriptionFile, true);
    } else if (newValue === '2') {
      getPrescriptionFile(OutNetFile);
    } else {
      getPrescriptionFile(InNetFile);
    }
    setValue(newValue);
  };

  const onSearchButtonClick = () => {
    setOffset(0);
    currentPageNumber.current = 0;
    // refetch({
    //   searchText: searchValue,
    //   offset: 0,
    // });
  };

  const onClearData = () => {
    setOffset(0);
    currentPageNumber.current = 0;
    setSearchValue('');
    // refetch({
    //   searchText: '',
    //   offset: 0,
    // });
  };

  // const leftClick = () => {
  //   if (offset !== 0) {
  //     setOffset(prevValue => prevValue - 1);
  //     currentPageNumber.current -= 1;
  //     refetch({
  //       offset: offset,
  //     });
  //   }
  // };

  // const rightClick = () => {
  //   setOffset(prevValue => prevValue + 1);
  //   currentPageNumber.current += 1;
  //   refetch({
  //     offset: offset,
  //   });
  // };

  return (
    <Content>
      <BreadcrumbComponent
        breadcrumbData={breadcrumbData}></BreadcrumbComponent>
      <Box sx={{ display: 'flex', justifyItems: 'center' }}>
        <Box
          component="img"
          height="40px"
          width="40px"
          src={
            menuItems
              ? getIconFromSubItemsArray(
                  menuItems?.Financial?.subItems,
                  'Coverage and benefits'
                )
              : null
          }
          alt={COVERAGE.TITLE_TEXT}
          sx={{ mr: 2 }}
        />
        <Typography variant="title">{state.title}</Typography>
      </Box>{' '}
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={value}>
          <Box
            sx={{
              display: 'flex',
              width: '100%',
              alignItems: 'center',
              justifyContent: 'space-between',
              alignSelf: 'flex-start',
              flexDirection: { sm: 'row', xs: 'column' },
              gap: { xs: '20px' },
            }}>
            <Box sx={{ mt: 3 }}>
              <TabList onChange={handleChange}>
                {activePlansPriceList?.IN_NETWORK_RATE ? (
                  <StyledTab label={PRICE_LIST.IN_NETWORK_RATE} value="1" />
                ) : null}
                {activePlansPriceList?.OUT_OF_NETWORK ? (
                  <StyledTab label={PRICE_LIST.OUT_OF_NETWORK} value="2" />
                ) : null}
                {activePlansPriceList?.PRESCRIPTION_DRUG ? (
                  <StyledTab label={PRICE_LIST.PRESCRIPTION_DRUG} value="3" />
                ) : null}
                {/* if no tabs are available in that case IN_NETWORK_RATE will show */}
                {!activePlansPriceList?.OUT_OF_NETWORK &&
                !activePlansPriceList?.PRESCRIPTION_DRUG &&
                !activePlansPriceList?.IN_NETWORK_RATE ? (
                  <StyledTab label={PRICE_LIST.IN_NETWORK_RATE} value="1" />
                ) : null}
              </TabList>
            </Box>

            {/* <SecondaryBtnComponent
              disabled={priceListData === null || priceListData.length < 1}
              title={PRICE_LIST.DOWNLOAD}
              sx={{ height: '38px' }}
              onClick={onDownloadClick}
            /> */}
          </Box>
          <Box sx={table}>
            <SearchBar
              placeholder={PRICE_LIST.SEARCH_BY_TEXT}
              sx={{
                width: '50%',
                mb: 3,
                minWidth: '340px',
                maxWidth: '500px',
              }}
              onSearch={onChangeText}
              onClearData={onClearData}
              value={searchValue}
              onSearchButtonClick={onSearchButtonClick}></SearchBar>
            {
              // !loading &&
              !priceListTableData.length >= 1 ? (
                <NotFound title={PRICE_LIST.NOT_FOUND_TEXT} />
              ) : (
                <>
                  <PricelistAGgrid
                    rowData={priceListTableData}
                    columnDefs={tableHeading}
                    coverage={true}
                  />
                  {/* {!prescription && (
                  <Box
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}>
                    <Button disabled={currentPageNumber.current === 0}>
                      <ChevronLeftIcon onClick={leftClick}></ChevronLeftIcon>
                    </Button>
                    <Button>
                      <ChevronRightIcon onClick={rightClick}></ChevronRightIcon>
                    </Button>
                  </Box>
                )} */}
                </>
              )
            }
          </Box>
        </TabContext>
      </Box>
      {/* <SimpleBackdrop open={loading} /> */}
    </Content>
  );
}

export default CoveragePriceList;
